import { Box } from "@mui/material";
import MediumSvg from "@/assets/svg/MediumSvg";
import TrustpilotSvg from "@/assets/svg/TrustpilotSvg";
import { styles } from "../stylesSidebar";

const links = [
  { icon: TrustpilotSvg, url: "https://www.trustpilot.com/review/wethemrkt.com", label: "Trustpilot" },
  { icon: MediumSvg, url: "https://medium.com/@wethemrkt", label: "Medium" },
];

const SocialLinks = ({ withDivider }: { withDivider: boolean }) => (
  <Box sx={withDivider ? styles.socialLinksWrapper : styles.socialLinksWrapperNoDivider}>
    <Box sx={styles.socialLinksRow}>
      {links.map(({ icon: Icon, url, label }) => (
        <Box
          key={label}
          component="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          sx={styles.socialLinkIcon}
        >
          <Icon />
        </Box>
      ))}
    </Box>
  </Box>
);

export default SocialLinks;
